import styled, { css } from "styled-components"

import TextCut from "~/components/molecules/TextCut"
import { IsMobile, IsPC } from "~/consts/style-mixins"
import { CompanyMember } from "~/entities/CompanyMember"

import User from "./User"

interface Props {
  user: CompanyMember
  className?: string
}

const CompanyMemberIntroductionItem = ({ user, className }: Props) => {
  return (
    <StyledItemWrapper className={className}>
      <StyledUser type="Large" iconPath={user.profileImgPath} name={user.name} label={user.position} />
      <TextCut size="Small" cutPoint={120}>
        {user.introduction || ""}
      </TextCut>
    </StyledItemWrapper>
  )
}

const StyledItemWrapper = styled.div`
  ${IsPC(css`
    display: flex;
  `)}
`

const StyledUser = styled(User)`
  min-width: 200px;
  margin: 0 24px 0 0;
  height: 100%;
  ${IsMobile(css`
    margin-bottom: 8px;
  `)}
`

export default CompanyMemberIntroductionItem
